// Brand asset paths
export const BRAND = {
  cover: '/brand/cover.png',
  problem: '/brand/problem.png',
  solution: '/brand/solution.png',
  howitworks: '/brand/howitworks.png',
};
